import * as types from './mutation-types'
import { ROUTE_NAME } from 'enums/routes'

const PAGE_SEO_MODEL = {
  MetaTitle: '',
  MetaDescription: '',
  Directives: '',
  Keyphrases: []
}

const PAGE_SEO_BY_ROUTE_NAME = {
  [ROUTE_NAME.HOMEPAGE]: {
    MetaTitle: 'Finance Magnates Awards 2026 | Nominations Closed',
    MetaDescription:
      'Nominations for the most influential B2C brokerage and B2B fintech brands, showcasing industry leadership, innovation, and impact, have been closed.',
    Directives: '',
    Keyphrases: []
  },
  [ROUTE_NAME.VOTING]: {
    MetaTitle: 'The Finance Magnates Annual Awards',
    MetaDescription:
      'Transform your success into recognition at the Finance Magnates Annual Awards. We celebrate financial excellence with a transparent, democratic, and inclusive process.',
    Directives: '',
    Keyphrases: []
  },
  [ROUTE_NAME.WINNERS]: {
    MetaTitle: 'The Finance Magnates Annual Awards | 2024 Winners',
    MetaDescription:
      'Finance Magnates Annual Awards 2024 winners global, regional & national honors from Broker of the Year to fintech innovation.',
    Directives: '',
    Keyphrases: []
  },
  [ROUTE_NAME.THANK_YOU]: {
    MetaTitle: 'Nomination Received | Finance Magnates Awards 2026',
    MetaDescription:
      'Thank You for nominating your brand for the Finance Magnates Awards 2026.',
    Directives: '',
    Keyphrases: []
  },
  [ROUTE_NAME.CEO_VOTING]: {
    MetaTitle: 'CEO of the Year Voting | FM Awards 2026',
    MetaDescription:
      'Vote for the CEO of the Year at the FM Awards 2026. Support leaders making an impact in online trading, prop trading, fintech and payments.',
    Directives: '',
    Keyphrases: []
  },
  [ROUTE_NAME.CEO_VOTING_THANK_YOU]: {
    MetaTitle: 'Thank You for Voting | CEO of the Year',
    MetaDescription:
      'Thank you for voting for the FM Awards 2026 CEO of the Year. Your vote helps recognise leaders making an impact across the financial industry.',
    Directives: '',
    Keyphrases: []
  }
}

export const state = () => ({
  pageSeo: { ...PAGE_SEO_MODEL },
  ogSiteName: ''
})

export const getters = {
  pageSeo: state => state.pageSeo,
  ogSiteName: state => state.ogSiteName
}

export const actions = {
  /**
   * TODO connect to BE here if requested
   */
  async requestPageSeo({ commit }, { routeName }) {
    const seoData = PAGE_SEO_BY_ROUTE_NAME[routeName]
    commit(types.SET_PAGE_SEO, seoData)
  }
}

export const mutations = {
  [types.SET_PAGE_SEO](state, seo) {
    state.pageSeo = seo || {}
  }
}
